var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 25,
    cy: 25,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)",
    fill: "#6E6E77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6247974,6.22405138 C20.8588295,5.99001923 20.8588295,5.60955626 20.6247974,5.37552411 C20.3907652,5.14149196 20.0103022,5.14149196 19.7762701,5.37552411 L13.0001607,12.1516335 L6.22405138,5.37552411 C5.99001923,5.14149196 5.60955626,5.14149196 5.37552411,5.37552411 C5.14149196,5.60955626 5.14149196,5.99001923 5.37552411,6.22405138 L12.1516335,13.0001607 L5.37552411,19.7762701 C5.14149196,20.0103022 5.14149196,20.3907652 5.37552411,20.6247974 C5.49312955,20.7424028 5.64673994,20.8 5.8004039,20.8 C5.95406787,20.8 6.10762467,20.7411705 6.22528369,20.6247974 L13.001393,13.848688 L19.7775024,20.6247974 C19.8951078,20.7424028 20.0487182,20.8 20.2023822,20.8 C20.3560462,20.8 20.509603,20.7411705 20.627262,20.6247974 C20.8612941,20.3907652 20.8612941,20.0103022 20.627262,19.7762701 L13.8511526,13.0001607 L20.6247974,6.22405138 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleIcon);
export default __webpack_public_path__ + "static/media/close-circle-icon.e691308b1693ddc7e0de86e11121bec0.svg";
export { ForwardRef as ReactComponent };